/* FITPEAK ライブ表示。実データのみ。取得できなければそのブロックを消す。 */
(function () {
  var ENDPOINT = 'https://fajqnrqfjugonbssssts.supabase.co/rest/v1/rpc/fp_home_ticker';
  var KEY = 'sb_publishable_Yzy7ryBHN4YTKCGqJkio6A_wYv2cq-n';
  var NAVI_URL = '/pages/compare';

  var CHANNEL = {
    amazon: { t: 'Amazon', c: 'am' },
    shopify: { t: '公式サイト', c: 'of' },
    official: { t: '公式サイト', c: 'of' },
    rakuten: { t: '楽天', c: 'rk' },
    yahoo: { t: 'Yahoo!', c: 'yh' }
  };

  var root = document.getElementById('fpTicker');
  var sales = document.getElementById('fpSales');
  var salesTrack = document.getElementById('fpSalesTrack');
  if (!root && !sales) return;

  var track = root ? root.querySelector('.fp__ticker-track') : null;
  var stamp = root ? root.querySelector('.fp__ticker-time') : null;

  function yen(n) { return '¥' + Number(n).toLocaleString('ja-JP'); }

  function ago(iso, suffix) {
    var m = (Date.now() - new Date(iso).getTime()) / 60000;
    if (!isFinite(m) || m < 0) return '';
    var s = suffix || '';
    if (m < 1) return 'たった今' + s;
    if (m < 60) return Math.floor(m) + '分前' + s;
    if (m < 2880) return Math.floor(m / 60) + '時間前' + s;
    return Math.floor(m / 1440) + '日前' + s;
  }

  function anchor(href, cls) {
    var el = document.createElement(href ? 'a' : 'span');
    el.className = cls;
    if (href) {
      el.href = href;
      if (/^https?:/.test(href)) { el.target = '_blank'; el.rel = 'noopener nofollow'; }
    }
    return el;
  }

  function handleOf(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function tickerNode(r) {
    var el = anchor(r.kind === 'purchase' ? r.url : NAVI_URL, 'fp__ticker-item');
    var tag = document.createElement('span');
    tag.className = 'fp__ticker-tag';
    tag.textContent = r.kind === 'purchase' ? '購入' : '最安';
    el.appendChild(tag);
    var name = document.createElement('span');
    name.textContent = r.label;
    el.appendChild(name);
    if (r.price) {
      var p = document.createElement('b');
      p.textContent = yen(r.price);
      el.appendChild(p);
    }
    return el;
  }

  function salesNode(r) {
    var el = anchor(r.url, 'fp__sales-item');

    var imgs = window.FP_PRODUCT_IMG || {};
    var src = imgs[handleOf(r.url)];
    if (src) {
      var im = document.createElement('img');
      im.src = src;
      im.alt = '';
      im.loading = 'lazy';
      el.appendChild(im);
    }

    var ch = CHANNEL[String(r.channel || 'amazon').toLowerCase()];
    if (ch) {
      var c = document.createElement('span');
      c.className = 'fp__sales-ch fp__sales-ch--' + ch.c;
      c.textContent = ch.t;
      el.appendChild(c);
    }

    if (r.pref) {
      var pf = document.createElement('span');
      pf.className = 'fp__sales-pref';
      pf.textContent = r.pref;
      el.appendChild(pf);
    }

    var name = document.createElement('b');
    name.textContent = r.label;
    el.appendChild(name);
    var txt = document.createElement('span');
    txt.textContent = 'が購入されました';
    el.appendChild(txt);
    var t = document.createElement('em');
    t.textContent = ago(r.at, '');
    el.appendChild(t);
    return el;
  }

  function drop(el) { if (el && el.parentNode) el.parentNode.removeChild(el); }

  /* マーキーは同じ並びを2回入れて -50% でループさせる。 */
  function fill(container, rows, make) {
    for (var pass = 0; pass < 2; pass++) {
      for (var i = 0; i < rows.length; i++) container.appendChild(make(rows[i]));
    }
  }

  fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'apikey': KEY,
      'Authorization': 'Bearer ' + KEY,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ p_limit: 14 })
  })
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (rows) {
      if (!rows || !rows.length) { drop(root); drop(sales); return; }

      var buys = rows.filter(function (r) { return r.kind === 'purchase'; });

      if (root && track) {
        fill(track, rows, tickerNode);
        if (stamp) stamp.textContent = ago(rows[0].at, '更新');
        track.style.animationDuration = Math.max(30, rows.length * 6) + 's';
        root.setAttribute('data-ready', 'true');
      } else { drop(root); }

      if (sales && salesTrack && buys.length) {
        fill(salesTrack, buys, salesNode);
        salesTrack.style.animationDuration = Math.max(26, buys.length * 7) + 's';
        sales.setAttribute('data-ready', 'true');
      } else { drop(sales); }
    })
    .catch(function () { drop(root); drop(sales); });
})();
